var map = {
	"./feed/app.config.js": 41208,
	"./help-centre/app.config.js": 9887,
	"./home/app.config.js": 72297,
	"./login/app.config.js": 16297,
	"./mdc/app.config.js": 48422,
	"./myaccount/app.config.js": 903,
	"./players/app.config.js": 61126,
	"./search/app.config.js": 74600,
	"./store/app.config.js": 38359
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 45595;